import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useIsTruncated } from '../../../hooks/useIsTruncated.js';
import { StyledAvatarContainer, LabelContainer, StyledTypography } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Avatar } from '../Avatar/components/Avatar.js';
import { Tooltip } from '../Tooltip/Tooltip/index.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var sizeToTitleFontSize = {
  '2xl': 'huge',
  xl: 'huge',
  lg: 'large',
  md: 'medium',
  sm: 'small',
  xs: 'tiny',
  xxs: 'tiny'
};
var sizeToSubtitleFontSize = {
  '2xl': 'small',
  xl: 'small',
  lg: 'tiny',
  md: 'tiny',
  sm: 'tiny',
  xs: 'tiny',
  xxs: 'tiny'
};
function AvatarWithLabel(props) {
  var title = props.title,
    subtitle = props.subtitle,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    className = props.className,
    _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'horizontal' : _props$alignment,
    _props$truncate = props.truncate,
    truncate = _props$truncate === void 0 ? true : _props$truncate,
    avatarTooltip = props.avatarTooltip,
    restProps = __rest(props, ["title", "subtitle", "size", "className", "alignment", "truncate", "avatarTooltip"]);
  var titleRef = useIsTruncated();
  var subtitleRef = useIsTruncated();
  var isTruncated = titleRef.isTruncated || subtitleRef.isTruncated;
  return /*#__PURE__*/jsxs(StyledAvatarContainer, {
    className: className,
    $alignment: alignment,
    children: [/*#__PURE__*/jsx(Avatar, _extends({
      size: size,
      tooltip: avatarTooltip
    }, restProps)), /*#__PURE__*/jsx(Tooltip, {
      disabled: !isTruncated,
      title: title + " " + subtitle,
      children: /*#__PURE__*/jsxs(LabelContainer, {
        $size: size,
        $alignment: alignment,
        children: [title && /*#__PURE__*/jsx(StyledTypography, {
          $truncate: truncate,
          ref: titleRef.ref,
          $appearance: "300",
          $fontSize: sizeToTitleFontSize[size],
          $lineHeight: "neutralized",
          $fontWeight: "medium",
          children: title
        }), subtitle && /*#__PURE__*/jsx(StyledTypography, {
          $truncate: truncate,
          ref: subtitleRef.ref,
          $appearance: "100",
          $fontSize: sizeToSubtitleFontSize[size],
          $lineHeight: "neutralized",
          $fontWeight: "regular",
          children: subtitle
        })]
      })
    })]
  });
}

export { AvatarWithLabel };
